import { api } from '../utils/apiClient';

export interface FunctionalLibraryItem {
  id: number;
  test_id: string;
  name: string;
  service: string;
  suite: string;
  business_criticality: string;
  tags: string[];
  avg_duration_ms: number | null;
  created_at: string;
  is_sample_library?: boolean;
  library_source?: string;
  constraints?: Record<string, unknown> | null;
}

export interface FunctionalLibraryListResponse {
  data: FunctionalLibraryItem[];
  total: number;
}

export interface FunctionalLibraryUploadResult {
  added?: number;
  updated?: number;
  skipped?: number;
  errors?: Array<string | { index?: number; error?: string }>;
}

export interface SampleFunctionalLibraryLoadResponse {
  added: number;
  skipped: number;
  history_runs_created?: number;
  history_results_inserted?: number;
}

export const listFunctionalLibrary = (
  projectId: string
): Promise<FunctionalLibraryListResponse> =>
  api.get<FunctionalLibraryListResponse>(
    `/functional/library?project_id=${projectId}`
  );

export const getFunctionalLibrarySummary = listFunctionalLibrary;

export const createFunctionalTest = (
  projectId: string,
  payload: {
    test_id: string;
    name: string;
    service: string;
    suite: string;
    business_criticality: string;
    tags: string[];
    avg_duration_ms: number | null;
  }
) => api.post(`/functional/library?project_id=${projectId}`, payload);

export const deleteFunctionalTest = (_projectId: string, testId: number) =>
  api.delete(`/functional/library/${testId}`);

export const deleteFunctionalLibrary = (projectId: string) =>
  api.delete(`/functional/library?project_id=${projectId}`);

export const uploadFunctionalLibrary = (
  projectId: string,
  records: unknown[]
): Promise<FunctionalLibraryUploadResult> =>
  api.post<FunctionalLibraryUploadResult>(
    `/functional/library/upload-library?project_id=${projectId}`,
    records
  );

export const loadSampleFunctionalLibrary = (
  projectId: string,
  source: 'manual' | 'onboarding_auto' = 'manual',
  bootstrapHistory = true
): Promise<SampleFunctionalLibraryLoadResponse> =>
  api.post<SampleFunctionalLibraryLoadResponse>(
    `/functional/library/load-sample?project_id=${projectId}&source=${source}&bootstrap_history=${bootstrapHistory}`
  );
